/* Accessible native disclosure menus; update cart badge from Horizon events. */
import { StandardEvents } from '@shopify/events';
(() => {
  const closeMenus = (target) => document.querySelectorAll('.abdi-mobile-menu[open], .abdi-submenu[open]').forEach(menu => {
    if (!target || !menu.contains(target)) menu.open = false;
  });
  document.addEventListener('click', event => {
    closeMenus(event.target);
    if (event.target.closest('.abdi-mobile-menu a')) closeMenus();
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const openMenu = document.querySelector('.abdi-mobile-menu[open], .abdi-submenu[open]');
    if (openMenu) { closeMenus(); openMenu.querySelector('summary')?.focus(); }
  });
  let cartRequest;
  const syncCart = async () => {
    if (cartRequest) return;
    cartRequest = true;
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + 'cart.js', {headers:{Accept:'application/json'}});
      if (!response.ok) return;
      const cart = await response.json();
      document.querySelectorAll('[data-abdi-cart-count]').forEach(badge => {
        badge.textContent = cart.item_count;
        badge.closest('a')?.setAttribute('aria-label', `Sepet, ${cart.item_count} ürün`);
      });
    } catch (_) { /* Existing server-rendered badge remains available offline. */ }
    finally { cartRequest = false; }
  };
  document.addEventListener(StandardEvents.cartLinesUpdate, event => {
    Promise.resolve(event.promise).then(syncCart).catch(() => {});
  });
  window.addEventListener('pageshow', event => { if (event.persisted) syncCart(); });
})();
